/* L'OREMONT PARIS — PDP-Interaktionen (eigenständig, reduced-motion-sicher) */
(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pointerFine = window.matchMedia('(pointer: fine)').matches;
  const hasGsap = typeof window.gsap !== 'undefined';
  const EASE = 'expo.out';

  /* ---------- Nav: solide + Scroll-Schatten ---------- */
  (function nav() {
    const nav = document.getElementById('nav');
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    const toggle = document.getElementById('nav-toggle');
    const panel = document.getElementById('nav-panel');
    if (!toggle || !panel) return;
    const links = panel.querySelectorAll('a');
    let open = false;
    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.toggle('is-open', open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (!open) setTimeout(() => { panel.hidden = true; }, 500);
    }
    toggle.addEventListener('click', () => setOpen(!open));
    links.forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) setOpen(false); });
  })();

  /* ---------- Galerie: Thumb-Wechsel ---------- */
  /* Gravur-Vorschau (Overlay auf dem Hero) verwaltet gravur.js selbst über data-mono am Thumb. */
  (function gallery() {
    const hero = document.getElementById('pdp-hero-img');
    const thumbs = document.querySelectorAll('.pdp-thumb');
    if (!hero || !thumbs.length) return;
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const src = t.dataset.src; if (!src || src === hero.getAttribute('src')) return;
      thumbs.forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      /* Hochformat-Lifestyle → cover (kein Letterbox), Freisteller → contain.
         Server-seitig markiert (data-fit am Thumb), sonst Naturmaß-Fallback. */
      const setFit = () => {
        if (t.dataset.fit) { hero.classList.toggle('is-cover', t.dataset.fit === 'cover'); return; }
        const apply = () => hero.classList.toggle('is-cover', hero.naturalHeight > hero.naturalWidth);
        if (hero.complete && hero.naturalWidth) apply();
        else hero.addEventListener('load', apply, { once: true });
      };
      if (hasGsap && !prefersReduced) {
        gsap.to(hero, { opacity: 0, duration: .2, onComplete: () => {
          hero.src = src; setFit();
          gsap.fromTo(hero, { opacity: 0, scale: 1.02 }, { opacity: 1, scale: 1, duration: .5, ease: EASE });
        }});
      } else { hero.src = src; setFit(); }
    }));
  })();

  /* ---------- Farb-Swatches: Variante + Galerie + Preis schalten ---------- */
  (function swatches() {
    const box = document.getElementById('pdp-swatches');
    if (!box) return; /* Fallback: Produkte ohne Farbe/Ausführung-Option → Select/Thumbs wie bisher */
    const hero = document.getElementById('pdp-hero-img');
    const nameEl = document.getElementById('pdp-swatch-name');
    const priceEl = document.getElementById('pdp-price');
    const addPrice = document.getElementById('pdp-add-price');
    const stickyPrice = document.getElementById('pdp-sticky-price');
    const thumbs = document.querySelectorAll('.pdp-thumb');

    function swapHero(src) {
      if (!hero || !src || src === hero.getAttribute('src')) return;
      /* Thumb markieren, falls das Varianten-Bild einem Thumb entspricht */
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.src === src));
      const setFit = () => {
        const apply = () => hero.classList.toggle('is-cover', hero.naturalHeight > hero.naturalWidth);
        if (hero.complete && hero.naturalWidth) apply();
        else hero.addEventListener('load', apply, { once: true });
      };
      if (hasGsap && !prefersReduced) {
        gsap.to(hero, { opacity: 0, duration: .2, onComplete: () => {
          hero.src = src; setFit();
          gsap.fromTo(hero, { opacity: 0, scale: 1.02 }, { opacity: 1, scale: 1, duration: .5, ease: EASE });
        }});
      } else { hero.src = src; setFit(); }
    }

    function applySeries(list) {
      if (!list || !list.length) return;
      swapHero(list[0]);
      const t = document.querySelectorAll('.pdp-thumb');
      t.forEach((el, i) => {
        if (i < list.length) {
          el.hidden = false;
          el.dataset.src = list[i];
          const im = el.querySelector('img'); if (im) im.src = list[i];
        } else {
          el.hidden = true; /* keine Fremdfarben-Bilder hinter der Serie */
        }
        el.classList.toggle('is-active', i === 0);
      });
    }

    /* Serie der vorausgewaehlten Farbe direkt beim Laden anwenden */
    const initR = box.querySelector('input[name="id"]:checked');
    if (initR && initR.dataset.images) setTimeout(() => applySeries(initR.dataset.images.split('|')), 0);

    box.querySelectorAll('input[name="id"]').forEach((r) => r.addEventListener('change', () => {
      if (!r.checked) return;
      if (nameEl && r.dataset.title) nameEl.textContent = r.dataset.title;
      if (r.dataset.price) {
        if (priceEl) priceEl.textContent = r.dataset.price;
        if (addPrice) addPrice.textContent = r.dataset.price;
        if (stickyPrice) stickyPrice.textContent = r.dataset.price;
      }
      /* Farbwechsel tauscht die GANZE Bildserie (Hero + Thumbs) —
         sonst zeigen die Thumbs weiter die alte Farbe. */
      if (r.dataset.images) applySeries(r.dataset.images.split('|'));
      else swapHero(r.dataset.image);
    }));
  })();

  /* ---------- Mobile Galerie: Swipe + Punkte unten mittig ----------
     Die Punkte spiegeln die sichtbaren Thumbs (Serie kann 3–5 Bilder haben) und
     bleiben über einen MutationObserver synchron, wenn der Farbwechsel die
     Serie tauscht. Ein Punkt-Klick klickt den zugehörigen Thumb — die gesamte
     Swap-Logik (Fade, Fit, Gravur-Overlay) bleibt an einer Stelle. */
  (function heroDots() {
    const media = document.querySelector('.pdp-hero-media');
    const thumbsBox = document.querySelector('.pdp-thumbs');
    if (!media || !thumbsBox) return;

    const dotsBox = document.createElement('div');
    dotsBox.className = 'pdp-dots';
    dotsBox.setAttribute('aria-hidden', 'true');
    media.appendChild(dotsBox);

    const visibleThumbs = () =>
      Array.from(thumbsBox.querySelectorAll('.pdp-thumb')).filter((t) => !t.hidden);

    function sync() {
      const thumbs = visibleThumbs();
      if (dotsBox.children.length !== thumbs.length) {
        dotsBox.innerHTML = '';
        thumbs.forEach((t, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'pdp-dot';
          d.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + thumbs.length);
          d.addEventListener('click', () => visibleThumbs()[i] && visibleThumbs()[i].click());
          dotsBox.appendChild(d);
        });
      }
      thumbs.forEach((t, i) => {
        const d = dotsBox.children[i];
        if (d) d.classList.toggle('is-active', t.classList.contains('is-active'));
      });
      dotsBox.classList.toggle('is-single', thumbs.length < 2);
    }

    let raf = 0;
    const queueSync = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); };
    new MutationObserver(queueSync).observe(thumbsBox, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'],
    });
    sync();

    /* Wischgeste auf dem Hauptbild: horizontal > 40px → nächstes/voriges Bild */
    let sx = 0, sy = 0, tracking = false;
    media.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    media.addEventListener('touchend', (e) => {
      if (!tracking) return; tracking = false;
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const thumbs = visibleThumbs();
      const cur = thumbs.findIndex((t) => t.classList.contains('is-active'));
      const next = dx < 0 ? cur + 1 : cur - 1;
      if (next >= 0 && next < thumbs.length) thumbs[next].click();
    }, { passive: true });
  })();

  /* ---------- Gravur/Personalisierung: komplett in gravur.js (snippets/gravur-feld.liquid) ---------- */
  /* ---------- Bundle-Boxen, Sticky-ATC, Rating-Zeile: pdp-conversion.js ---------- */

  /* ---------- „In den Warenkorb": echtes Shopify-Formular (nativer Submit) ---------- */

  /* ---------- Sanfter Tilt auf dem Hauptbild (Desktop) ---------- */
  if (pointerFine && !prefersReduced && hasGsap) {
    const media = document.querySelector('.pdp-hero-media');
    if (media) {
      gsap.set(media, { transformPerspective: 1000 });
      const rx = gsap.quickTo(media, 'rotationX', { duration: .5, ease: EASE });
      const ry = gsap.quickTo(media, 'rotationY', { duration: .5, ease: EASE });
      media.addEventListener('pointermove', (e) => {
        const r = media.getBoundingClientRect();
        rx(gsap.utils.clamp(-4, 4, -((e.clientY - r.top) / r.height - .5) * 8));
        ry(gsap.utils.clamp(-4, 4, ((e.clientX - r.left) / r.width - .5) * 8));
      });
      media.addEventListener('pointerleave', () => { rx(0); ry(0); });
    }
    document.querySelectorAll('.btn-gold').forEach((b) => {
      const bx = gsap.quickTo(b, 'x', { duration: .45, ease: EASE });
      const by = gsap.quickTo(b, 'y', { duration: .45, ease: EASE });
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        bx(gsap.utils.clamp(-8, 8, (e.clientX - r.left - r.width / 2) * .25));
        by(gsap.utils.clamp(-8, 8, (e.clientY - r.top - r.height / 2) * .3));
      });
      b.addEventListener('pointerleave', () => { bx(0); by(0); });
    });
  }

  /* ---------- Bundle-Boxen: Stagger-Einblendung beim Laden ---------- */
  (function bundleIntro() {
    if (!hasGsap || prefersReduced) return;
    const boxes = document.querySelectorAll('.pdp-bundle-box');
    if (!boxes.length) return;
    gsap.fromTo(boxes, { opacity: 0, y: 16 },
      { opacity: 1, y: 0, duration: .9, ease: EASE, stagger: .09, delay: .15, clearProps: 'opacity,transform' });
  })();

  /* ---------- Scroll-Reveals: Objection / Reviews / Editorial ----------
     Nur transform/opacity/clip-path. Versteckt wird NUR per JS und NUR, was beim
     Init unterhalb des Viewports liegt — fällt JS aus, ist alles sichtbar.
     4s-Failsafe erzwingt den Endzustand. */
  (function sectionReveals() {
    if (!hasGsap || prefersReduced) return;
    const RISE = '.pdp-objection .eyebrow, .pdp-objection h2, .pdp-objection-intro, ' +
      '.pdp-objection-point, .pdp-objection-quote, .pdp-reviews-head, .pdp-review-card, ' +
      '.pdp-editorial-copy .eyebrow, .pdp-editorial-copy .h2-display, .pdp-editorial-text, .pdp-editorial-cta';
    const CLIP = '.pdp-editorial-a, .pdp-editorial-b';
    const vh = window.innerHeight;
    const pending = [];

    /* Stagger: Reihenfolge je Elterngruppe merken */
    const groupIndex = new Map();
    function delayFor(el) {
      const p = el.parentElement || el;
      const i = groupIndex.get(p) || 0;
      groupIndex.set(p, i + 1);
      return Math.min(i, 5) * 0.08;
    }

    const show = (el) => {
      if (el.dataset.pdpRevealed) return;
      el.dataset.pdpRevealed = '1';
      if (el.dataset.pdpClip) {
        gsap.to(el, { clipPath: 'inset(0% 0 0% 0)', duration: 1.2, ease: 'expo.inOut', overwrite: 'auto', clearProps: 'clipPath' });
      } else {
        gsap.to(el, { opacity: 1, y: 0, duration: 1, ease: EASE, delay: parseFloat(el.dataset.pdpDelay || '0'), overwrite: 'auto' });
      }
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); show(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });

    document.querySelectorAll(RISE).forEach((el) => {
      if (el.getBoundingClientRect().top < vh) return; /* sichtbar lassen */
      el.dataset.pdpDelay = String(delayFor(el));
      gsap.set(el, { opacity: 0, y: 30 });
      pending.push(el); io.observe(el);
    });
    document.querySelectorAll(CLIP).forEach((el) => {
      if (el.getBoundingClientRect().top < vh) return;
      el.dataset.pdpClip = '1';
      gsap.set(el, { clipPath: 'inset(0 0 100% 0)' });
      pending.push(el); io.observe(el);
    });

    /* Failsafe: nichts darf dauerhaft unsichtbar hängen */
    setTimeout(() => pending.forEach((el) => {
      if (el.dataset.pdpRevealed) return;
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.dataset.pdpRevealed = '1';
        gsap.set(el, { opacity: 1, y: 0, clipPath: 'none' });
      }
    }), 4000);
  })();

  /* ---------- Bundle-Reveal (mit garantiertem Endzustand) ---------- */
  (function reveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (prefersReduced || !hasGsap) { els.forEach((e) => { e.style.opacity = 1; e.style.transform = 'none'; }); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); gsap.to(e.target, { opacity: 1, y: 0, duration: 1, ease: EASE }); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    els.forEach((e) => { if (e.getBoundingClientRect().top < window.innerHeight) gsap.set(e, { opacity: 1, y: 0 }); else io.observe(e); });
    setTimeout(() => els.forEach((e) => { if (getComputedStyle(e).opacity === '0') gsap.set(e, { opacity: 1, y: 0 }); }), 3500);
  })();
})();
